
import { IUsersTranslations } from '../';

const users: IUsersTranslations = {
  name: 'Nome',
  users: 'Utilizadores',
  email: 'Email',
  phone: 'Número de telemóvel',
  deleteUsers: 'Destruir utilizadores',
  delete_users_confirm: 'Tem a certeza que pretende apagar definitivamente os utilizadores selecionados? Apenas para contas sem atividade, como contas de teste. Para pedidos de proteção de dados use Eliminar dados. Esta ação não pode ser desfeita.',
  erase_action: 'Eliminar dados (RGPD)',
  erase_title: 'Eliminar os dados desta conta',
  erase_hint: 'Use para pedidos de proteção de dados. Depois de eliminada:',
  erase_effect_locked_out: 'Deixa de poder iniciar sessão e deixamos de a contactar. O email e o telemóvel de acesso ficam livres para uma nova conta.',
  erase_effect_profile_removed: 'O perfil (nome, telefone, data de nascimento, localização, preferências) é removido.',
  erase_effect_records_kept: 'Compras, faturas, bilhetes e inscrições em eventos são mantidos para os organizadores e para a contabilidade.',
  erase_checking: 'A verificar se esta conta pode ser eliminada…',
  erase_check_failed: 'Não foi possível verificar esta conta',
  erase_blocked_title: 'Esta conta ainda não pode ser eliminada:',
  erase_blocker_is_staff: 'Contas de staff não podem ser eliminadas.',
  erase_blocker_already_erased: 'Esta conta já foi eliminada.',
  erase_blocker_holds_upcoming_tickets: 'Tem bilhetes para eventos que ainda não terminaram. Têm de ser transferidos para outra pessoa primeiro.',
  erase_blocker_sole_manager_of_upcoming_event: 'É o único gestor de eventos que ainda não terminaram. Adicione outro gestor primeiro.',
  erase_ticket_refs: 'Bilhetes:',
  erase_event_refs: 'Eventos:',
  erase_recheck: 'Verificar novamente',
  erase_reason: 'Motivo ou referência do pedido',
  erase_reason_placeholder: 'ex.: pedido de suporte #1234',
  erase_confirm_label: 'Escreva o email do utilizador para confirmar',
  erase_submit: 'Eliminar conta',
  erase_success: 'Conta eliminada',
  erase_failed: 'Não foi possível eliminar esta conta',
};

export default users;
